import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import { getRefreshUrl } from '../helpers/getRefreshUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const UniversalAssociationsSelectSearchPaneError = () => {
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    padding: "200",
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(Alert, {
      type: "danger",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "universalAssociationsSelect.searchPaneError_jsx",
        options: {
          href: getRefreshUrl()
        },
        elements: {
          Link
        }
      })
    })
  });
};
export default UniversalAssociationsSelectSearchPaneError;